<div class="container-box shadow-none">
  <div class="d-flex gap-3 align-items-center p-3">
    <img src="/assets/images/channel-wizards/step-icon2.webp" alt="" height="40" />
    <div>
      <h6 class="mb-0" i18n>Request Channel Manager Access</h6>
      <div class="text-sm" i18n>
        This section can take between 10 minutes and 2 hrs depending on the volume of requests.
      </div>
    </div>
  </div>
  <div class="border-top p-4 d-flex gap-5">
    <div class="flex-fill">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true" #settings>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">1</div>
              <ng-container i18n>Login to Account</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p i18n>
              Open a new browser window, log into Expedia Partner Central, and use the Contact Us form to request
              AdvanceCM as your channel manager.
            </p>
            <img src="/assets/images/channel-wizards/expedia/login.webp" alt="" height="250" />
            <p class="mt-3" i18n>Please include your Expedia Hotel ID with your requests.</p>
            <img src="/assets/images/channel-wizards/expedia/hotel-id.webp" alt="" />

            <div class="text-right">
              <button class="btn btn-light-info" (click)="enterPropertyId.open()">
                <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
              </button>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel #enterPropertyId>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">3</div>
              <ng-container i18n>Enter Property ID</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mb-3">
            <p i18n>Please enter your property or hotel ID below.</p>
            <mat-form-field2 [showLabel]="false" class="w-50">
              <input
                matInput
                i18n-placeholder
                placeholder="Enter Property ID"
                [formControl]="propertyIdCtrl"
                required
              />
              <mat-error i18n *ngIf="propertyIdCtrl.touched && propertyIdCtrl.hasError('required')">
                Property ID is required
              </mat-error>
            </mat-form-field2>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div style="max-width: 450px">
      <img src="/assets/images/channel-wizards/expedia/step3.webp" alt="" class="w-100" />
    </div>
  </div>
</div>
<div class="mt-3 d-flex align-items-center justify-content-between">
  <button class="btn btn-outline-light" (click)="prev.emit()">
    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
    <ng-container i18n>Previous</ng-container>
  </button>
  <button
    class="btn btn-secondary-info"
    matTooltip="Please enter property ID to connect to Expedia"
    i18n-matTooltip
    [disabled]="propertyIdCtrl.invalid || isConnecting"
    (click)="onConnect(propertyIdCtrl)"
  >
    <ng-container i18n>Connect</ng-container>
    <i class="far fa-spin fa-spinner" *ngIf="isConnecting"></i>
    <i class="cs-icon cs-icon-arrow-right-long text-xxs" *ngIf="!isConnecting"></i>
  </button>
</div>
